import { useConfig } from 'src/app/shared/hooks/useConfig';
import { useHirerAccount } from 'src/app/v2/hooks/useHirerAccount';
import { useGetLocationQuery } from 'src/graphql/generated';

export const useLocationQuery = (locationId: string) => {
  const hirerAccount = useHirerAccount();
  const { getLanguage } = useConfig();

  const { data: { location } = {} } = useGetLocationQuery({
    variables: {
      locationId,
      contextualCountry: hirerAccount?.nation,
      language: getLanguage(),
    },
    skip: !locationId || !hirerAccount?.nation,
    fetchPolicy: 'cache-first',
  });

  return location;
};
